<template>
  <div id="app-heard">
    <div class="heard-top">
      <div class="heard-box">
        <div class="heard-left">
          <span>{{yearData}} {{weekData}}</span>
          <i>农历{{nl_year}} {{hoursTime}}</i>
          <i style="color:whitesmoke">| {{ unit_name }}</i>
        </div>
        <div class="heard-right">
          <span style="margin-right: 20px"
                @click="centerDialogVisible = true"
                v-if="wechatDialog">绑定微信</span>
          <div class="name-box">
            <i>
              <!-- <img src="../../../assets/images/logo.png" alt="" style="max-width: 25px"> -->
            </i>
            <span>{{ user_name }}</span>
          </div>
          <span @click="loginOut">退出</span>
        </div>
      </div>
    </div>
    <!-- <div v-if="showNotice" style="max-width: 100%; height: 40px; line-height: 40px; overflow: hidden; margin-right: calc(50% - 600px); margin-left: calc(50% - 600px)">
          <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="1" style="margin-left: 5px">
              <i class="el-icon-info" style="color: #e6a23c"></i>
            </el-col>  
            <el-col :span="23" style="overflow: hidden;">
              <vue-seamless-scroll :data="listData" :class-option="option">
                <p class="item"><span v-for="(item,index) in listData" :key="index"><router-link :to="item.url">{{item.title}}31231231</router-link>&nbsp;&nbsp;&nbsp;&nbsp;</span></p>
              </vue-seamless-scroll>
            </el-col>
          </el-row>       
    </div>-->

    <el-alert v-if="ifAudit == 1 && !(userInfo.practice_license && userInfo.practice_license != '')"
              title="该单位信息处于未完善状态，请管理员先完善单位信息~"
              type="warning"
              style="padding-left: calc(50% - 600px)"
              :closable="false"
              show-icon></el-alert>

    <el-alert v-if="ifAudit == 0"
              title="您的账号状态为未审核，不能进行操作。请等待基金会管理员进行审核。"
              type="warning"
              style="padding-left: calc(50% - 600px)"
              :closable="false"
              show-icon></el-alert>
    <el-alert title="您的账号状态为审核不通过，不能进行操作。请修改单位信息并等待基金会管理员进行再次审核。"
              type="error"
              v-if="ifAudit == 2"
              :description="'审核意见：'+audit_note"
              style="padding-left: calc(50% - 600px)"
              :closable="false"
              show-icon></el-alert>
    <el-dialog ref="qrcodeDialog"
               title="提示"
               :visible.sync="centerDialogVisible"
               width="30%"
               center>
      <el-alert title="您的账号尚未绑定微信，无法实时接收消息，请及时绑定。（绑定微信前请先关注公众号）"
                type="warning"
                :closable="false"
                show-icon></el-alert>
      <span slot="footer"
            class="dialog-footer">
        <el-row type="flex"
                class="row-bg"
                justify="center">
          <el-col :span="10">
            <!-- <div id="qrcode1" align="center"> -->
            <img src="../../../assets/images/code.png"
                 style="width:100px;height:100px"
                 alt />
            <!-- </div> -->
            <p style="text-align: center;margin-top: 10px; font-family: '微软雅黑'; font-size: 14px">关注公众号</p>
          </el-col>
          <el-col :span="4"
                  style="vertical-align: middle;">
            <i class="el-icon-arrow-right"
               style="font-size: 40px; margin-top: 36px"></i>
          </el-col>
          <el-col :span="10">
            <div id="qrcode2"
                 align="center">
              <!--  <img src="../../../assets/images/code.png" alt=""> -->
            </div>
            <p style="text-align: center;margin-top: 10px; font-family: '微软雅黑'; font-size: 14px">绑定微信</p>
          </el-col>
        </el-row>
        <el-row type="flex"
                class="row-bg"
                justify="center">
          <el-col :span="24">
            <el-button @click="centerDialogVisible = false"
                       style="margin-top: 40px">关 闭</el-button>
          </el-col>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  data () {
    return {
      qrcode2_url: "",
      ifAudit: null, //是否审核通过
      audit_note: null, //审核意见
      centerDialogVisible: false,
      // showNotice: false,
      wechatDialog: false,
      userInfo: {},

      option: {
        step: 0.5,
        limitMoveNum: 1,
        direction: 2,
        waitTime: 500,
      },
      listData: [],
      unit_name: null, //单位名称
      user_name: null, //用户名称
      school: {},
      user_id: "",
      yearData: "",
      dayData: "",
      weekData: "",
      shengxiao: "",
      nl_year: "",
      nl_date: "",
      hoursTime: "",
      times: "",
      sWeek: new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ),

      CalendarData: new Array(100),
      madd: new Array(12),
      tgString: "甲乙丙丁戊己庚辛壬癸",
      dzString: "子丑寅卯辰巳午未申酉戌亥",
      numString: "一二三四五六七八九十",
      monString: "正二三四五六七八九十冬腊",
      weekString: "日一二三四五六",
      sx: "鼠牛虎兔龙蛇马羊猴鸡狗猪",
      cYear: "",
      cMonth: "",
      cDay: "",
      TheDate: "",
      CalendarData: new Array(
        0xa4b,
        0x5164b,
        0x6a5,
        0x6d4,
        0x415b5,
        0x2b6,
        0x957,
        0x2092f,
        0x497,
        0x60c96,
        0xd4a,
        0xea5,
        0x50da9,
        0x5ad,
        0x2b6,
        0x3126e,
        0x92e,
        0x7192d,
        0xc95,
        0xd4a,
        0x61b4a,
        0xb55,
        0x56a,
        0x4155b,
        0x25d,
        0x92d,
        0x2192b,
        0xa95,
        0x71695,
        0x6ca,
        0xb55,
        0x50ab5,
        0x4da,
        0xa5b,
        0x30a57,
        0x52b,
        0x8152a,
        0xe95,
        0x6aa,
        0x615aa,
        0xab5,
        0x4b6,
        0x414ae,
        0xa57,
        0x526,
        0x31d26,
        0xd95,
        0x70b55,
        0x56a,
        0x96d,
        0x5095d,
        0x4ad,
        0xa4d,
        0x41a4d,
        0xd25,
        0x81aa5,
        0xb54,
        0xb6a,
        0x612da,
        0x95b,
        0x49b,
        0x41497,
        0xa4b,
        0xa164b,
        0x6a5,
        0x6d4,
        0x615b4,
        0xab6,
        0x957,
        0x5092f,
        0x497,
        0x64b,
        0x30d4a,
        0xea5,
        0x80d65,
        0x5ac,
        0xab6,
        0x5126d,
        0x92e,
        0xc96,
        0x41a95,
        0xd4a,
        0xda5,
        0x20b55,
        0x56a,
        0x7155b,
        0x25d,
        0x92d,
        0x5192b,
        0xa95,
        0xb4a,
        0x416aa,
        0xad5,
        0x90ab5,
        0x4ba,
        0xa5b,
        0x60a57,
        0x52b,
        0xa93,
        0x40e95
      ),
    };
  },
  methods: {
    createQrcode () {
      // let qrcode1 = new QRCode('qrcode1', {
      //   width: 100,
      //   height: 100, // 高度
      //   text: 'http://www.baidu.com'
      // })

      let qrcode2 = new QRCode("qrcode2", {
        width: 100,
        height: 100, // 高度
        text: this.qrcode2_url,
      });
    },
    getDate () {
      setInterval(() => {
        var d = new Date();
        this.yearData =
          d.getFullYear() +
          "年" +
          (d.getMonth() + 1) +
          "月" +
          d.getDate() +
          "日";
        var hours = d.getHours();
        hours = hours < 10 ? "0" + hours : hours;
        var min = d.getMinutes();
        min = min < 10 ? "0" + min : min;
        this.dayData = hours + ":" + min;
        // var week = new Date().getDay();
        this.weekData = "星期" + "日一二三四五六".charAt(new Date().getDay());
        if (hours == 23 || hours == 24) {
          this.hoursTime = "子时";
        } else if (hours == 1 || hours == 2) {
          this.hoursTime = "丑时";
        } else if (hours == 3 || hours == 4) {
          this.hoursTime = "寅时";
        } else if (hours == 5 || hours == 6) {
          this.hoursTime = "卯时";
        } else if (hours == 7 || hours == 8) {
          this.hoursTime = "辰时";
        } else if (hours == 9 || hours == 10) {
          this.hoursTime = "巳时";
        } else if (hours == 11 || hours == 12) {
          this.hoursTime = "午时";
        } else if (hours == 13 || hours == 14) {
          this.hoursTime = "未时";
        } else if (hours == 15 || hours == 16) {
          this.hoursTime = "申时";
        } else if (hours == 17 || hours == 18) {
          this.hoursTime = "酉时";
        } else if (hours == 19 || hours == 20) {
          this.hoursTime = "戌时";
        } else if (hours == 21 || hours == 22) {
          this.hoursTime = "亥时";
        }
      }, 60000);
    },
    GetBit (m, n) {
      return (m >> n) & 1;
    },
    e2c () {
      this.madd[0] = 0;
      this.madd[1] = 31;
      this.madd[2] = 59;
      this.madd[3] = 90;
      this.madd[4] = 120;
      this.madd[5] = 151;
      this.madd[6] = 181;
      this.madd[7] = 212;
      this.madd[8] = 243;
      this.madd[9] = 273;
      this.madd[10] = 304;
      this.madd[11] = 334;
      this.TheDate =
        arguments.length != 3
          ? new Date()
          : new Date(arguments[0], arguments[1], arguments[2]);
      var total, m, n, k;
      var isEnd = false;
      var tmp = this.TheDate.getFullYear();
      total =
        (tmp - 1921) * 365 +
        Math.floor((tmp - 1921) / 4) +
        this.madd[this.TheDate.getMonth()] +
        this.TheDate.getDate() -
        38;
      if (this.TheDate.getYear() % 4 == 0 && this.TheDate.getMonth() > 1) {
        total++;
      }
      for (m = 0; ; m++) {
        k = this.CalendarData[m] < 0xfff ? 11 : 12;
        for (n = k; n >= 0; n--) {
          if (total <= 29 + this.GetBit(this.CalendarData[m], n)) {
            isEnd = true;
            break;
          }
          total = total - 29 - this.GetBit(this.CalendarData[m], n);
        }
        if (isEnd) break;
      }
      this.cYear = 1921 + m;
      this.cMonth = k - n + 1;
      this.cDay = total;
      if (k == 12) {
        if (this.cMonth == Math.floor(this.CalendarData[m] / 0x10000) + 1) {
          this.cMonth = 1 - this.cMonth;
        }
        if (this.cMonth > Math.floor(this.CalendarData[m] / 0x10000) + 1) {
          this.cMonth--;
        }
      }
    },
    GetcDateString () {
      var tmp = "";
      tmp += this.tgString.charAt((this.cYear - 4) % 10);
      tmp += this.dzString.charAt((this.cYear - 4) % 12);
      tmp += "年" + "(" + this.shengxiao + ") ";
      if (this.cMonth < 1) {
        tmp += "(闰)";
        tmp += this.monString.charAt(-this.cMonth - 1);
      } else {
        tmp += this.monString.charAt(this.cMonth - 1);
      }
      tmp += "月";
      tmp +=
        this.cDay < 11
          ? "初"
          : this.cDay < 20
            ? "十"
            : this.cDay < 30
              ? "廿"
              : "三十";
      if (this.cDay % 10 != 0 || this.cDay == 10) {
        tmp += this.numString.charAt((this.cDay - 1) % 10);
      }
      this.nl_year = tmp;
      return tmp;
    },
    GetLunarDay (solarYear, solarMonth, solarDay) {
      if (solarYear < 1921 || solarYear > 2200) {
        return "";
      } else {
        solarMonth = parseInt(solarMonth) > 0 ? solarMonth - 1 : 11;
        this.e2c(solarYear, solarMonth, solarDay);
        this.getZodiac(solarYear);
        return this.GetcDateString();
      }
    },
    getZodiac (birth) {
      birth += "";
      var year = new Date(birth).getFullYear();
      var arr = [
        "猴",
        "鸡",
        "狗",
        "猪",
        "鼠",
        "牛",
        "虎",
        "兔",
        "龙",
        "蛇",
        "马",
        "羊",
      ];
      this.shengxiao = /^\d{4}$/.test(year) ? arr[year % 12] : "";

      // return /^\d{4}$/.test(year) ? arr[year % 12] : "";
    },
    showDate () {
      // var dNow = new Date();
      var D = new Date();
      var yy = D.getFullYear();
      var mm = D.getMonth() + 1;
      var dd = D.getDate();
      var ww = D.getDay();
      // var ss = parseInt(D.getTime() / 1000);
      var hours = D.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = D.getMinutes();
      min = min < 10 ? "0" + min : min;
      this.dayData = hours + ":" + min;
      this.yearData =
        D.getFullYear() + "年" + (D.getMonth() + 1) + "月" + D.getDate() + "日";
      this.weekData = this.sWeek[D.getDay()];
      this.GetLunarDay(yy, mm, dd);
      // console.log(sValue);
    },
    loginOut () {
      sessionStorage.removeItem("unitAuth");
      sessionStorage.removeItem("token");
      this.$message({
        type: "success",
        message: "退出登录成功！",
      });
      let that = this;
      setTimeout(function () {
        that.$router.push({ name: "unitLogin" });
      }, 2000);
    },
  },
  created () {
    if (!sessionStorage.getItem("unitAuth")) {
      return this.$router.push({ name: "unitLogin" });
    } else {
      this.getDate();
      this.qrcode2_url = "https://www.baidu.com";
      this.showDate();
      let userInfo = JSON.parse(sessionStorage.getItem("unitAuth"));
      this.userInfo = userInfo;
      this.ifAudit = userInfo.audit_status;
      this.unit_name = userInfo.unit_name;
      this.user_name = userInfo.user_name;
      this.audit_note = userInfo.audit_note;
    }
  },
};
</script>
<style lang="scss" scoped>
.item > span > a {
  color: #e6a23c;
}
.item {
  font-size: 12px;
  font-family: "微软雅黑";
  color: whitesmoke;
}
#app-heard {
  width: 100%;
  // background-color: #fff;
}
.heard-top {
  width: 100%;
  // height: 58px;
  background-color: #b60205;
  .heard-box {
    // height: 100%;
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    // line-height: 58px;
    padding: 16px 0;
    font-size: 14px;
    .heard-left {
      > span {
        font-size: 14px;
        color: #fff;
      }
      > i {
        color: #fddcb1;
        font-style: normal;
      }
    }
    .heard-right {
      // height: 100%;
      display: flex;
      .name-box {
        position: relative;
        padding-left: 35px;
        > i {
          display: block;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
        > span {
          font-size: 14px;
          color: #fff;
        }
      }
      > span {
        font-size: 14px;
        color: #fddcb1;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
}
.heard-bottom {
  width: 100%;
  background-color: #fff;
  .heard-bos {
    margin: 0 auto;
    max-width: 1200px;
    position: relative;
    padding: 28px 0;
    display: flex;
    justify-content: space-between;
    .logo-box {
      width: 400px;
      height: 74px;
      > img {
        width: 100%;
        height: 100%;
      }
    }
    .heard-title {
      width: 414px;
      height: 65px;
      margin-top: 4px;
      > p {
        font-size: 30px;
        color: #333;
        line-height: 65px;
        padding-left: 28px;
        border-left: 1px solid #999;
      }
    }
    .heard-search {
      position: relative;
      > input {
        background: none;
        outline: none;
        border: 0px;
        width: 280px;
        height: 47px;
        background-color: #ffffff;
        border-radius: 6px;
        border: solid 1px #cccccc;
        font-size: 16px;
        color: #999999;
        padding: 0 22px;
        margin-top: 9px;
      }
      > i {
        // display: block;
        width: 20px;
        height: 20px;
        position: absolute;
        right: 22px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
.position-box {
  max-width: 1200px;
  margin: 0 auto;
  color: #a0a0a0;
  // background-color: #fff;
  > p {
    line-height: 55px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hospital/public/center_head.vue